module.exports = __webpack_public_path__ + "assets/img/yingye.3fc39fe1.svg";